import { createContext, useContext } from 'react';
import { useMipManageController } from './useMipManageController';

export type MipManageContextValue = ReturnType<typeof useMipManageController>;

export const MIPManageContext = createContext<MipManageContextValue | undefined>(undefined);

export const useMIPManageContext = (): MipManageContextValue => {
	const context = useContext(MIPManageContext);
	if (!context) {
		throw new Error('useMIPManageContext must be used within MIPManageContext.Provider');
	}
	return context;
};

export const useOptionalMIPManageContext = (): MipManageContextValue | undefined =>
	useContext(MIPManageContext);
